/**
 * **NOTE** The utility in this file are a direct copy of a function found in the preview component of:
 * `src/modules/templateEditor/EditWhatsApp/preview/`. This exists as a copy so that if something changes in the
 * templateEditor module, it won't break the utility here that is meant to be a temporary solution.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

// Preprocessing for passing message content to WA preview to override formatting to render bold content. WA uses *{content}* for bold rendering
// but standard markdown treats that as italics so we need to replace the surrounding * with surrounding __ for bold rendering. This only affects
// preview rendering and WA messages will be sent with * to render on devices correctly.
export const whatsAppPreProcessor = (markdown: string) => {
  const whatsAppBoldFormatting = /([^\*]?)\*{1}([^\*]+)\*{1}([^\*]?)/g;

  return markdown.replaceAll(whatsAppBoldFormatting, (_, g1, g2, g3) => `${g1}__${g2}__${g3}`);
};
